import styled from "@emotion/styled";

import { commonColors } from "application/theme";
import { ShareDealBannerImage } from "application/assets";

export const Wrapper = styled("div")`
  height: 206px;
  display: flex;
  align-items: flex-start;
  padding: 20px 16px;
  gap: 16px;
  border-radius: 16px;
  background: url(${ShareDealBannerImage});
  background-size: cover;

  > p {
    color: ${commonColors.white};
    font-family: Unica77;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;

    > span {
      color: ${commonColors.lemonPie};
    }
  }

  > button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    border-radius: 100px;
    background-color: ${commonColors.blue700};

    > svg {
      width: 34px;
      height: 34px;
    }
  }
`;
